"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePackageSelectionLogic = void 0;
var _react = require("react");
var _contexts = require("../contexts");
const usePackageSelectionLogic = filter => {
  const {
    types,
    isLoading
  } = (0, _react.useContext)(_contexts.typesContext);
  const [packages, setPackages] = (0, _react.useState)([]);
  const categories = types.filter(type => type.isSubscriptionEnabled);

  // logic for sorting and merging the packages

  (0, _react.useEffect)(() => {
    const filteredPackages = types.map(type => {
      if ((type.typeId === filter || !filter) && type.isSubscriptionEnabled) {
        return type.packages;
      }
      return [];
    });
    const flatPackages = filteredPackages.flat();
    setPackages(flatPackages);
  }, [filter, types]);
  return {
    packages,
    categories,
    isLoading
  };
};
exports.usePackageSelectionLogic = usePackageSelectionLogic;
